import $ from 'jquery';

const hideLoadingImage = () => {
	$('.loading-wrapper').addClass('-invisible');
	setTimeout(() => $('.loading-wrapper').addClass('-hide'), 1500);
};

export default hideLoadingImage;



// WEBPACK FOOTER //
// ./src/js/common/hideLoadingImage.js